import './App.scss';

import Routes from '@/routes/index';
import AnalyticsRuntime from '@/utils/analytics-runtime';

function App() {
	return (
		<div className="App">
			<AnalyticsRuntime />
			<Routes />
		</div>
	);
}

export default App;
